import { Injectable } from '@angular/core';
import { SessionService } from '@com-delta-idp/mnx-oauth';
import { Membership } from '@com-delta-idp/mnx-sky-club-ui';
import { StateFacade as SharedStateFacade } from '@com-delta-idp/mnx-skymiles-shared';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import * as Actions from '../+state/actions';
import * as Selectors from '../+state/selectors';
import { DataLayerAnalyticsService } from '../services/analytics/data-layer.service';
import { getAddToCartRequest } from '../utils/add-to-cart.utils';
@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  title$ = this.store.pipe(select(Selectors.getTitle));
  overview$ = this.store.pipe(select(Selectors.getOverview));
  purchase$ = this.store.pipe(select(Selectors.getPurchase));
  checkout$ = this.store.pipe(select(Selectors.getCheckout));
  fullPageError$ = this.store.pipe(select(Selectors.getFullPageErrorMessage));
  isLoggedIn$ = this.session.userData$.pipe(map((user) => !!user.loggedIn));

  constructor(
    private readonly store: Store,
    public datalayer: DataLayerAnalyticsService,
    private session: SessionService,
    private readonly shared: SharedStateFacade
  ) {}

  init(): void {
    this.shared.init();
    this.store.dispatch(Actions.loadAEMContent());
    this.store.dispatch(Actions.loadPurchaseContent());
    this.datalayer.setDataForAnalyticsOnLoad();
  }

  addToCart(membership: Membership) {
    this.store.dispatch(
      Actions.loadAddToCart({
        data: {
          addToCart: getAddToCartRequest(membership.detail),
          value: membership.value
        }
      })
    );
  }
}
